export default __webpack_public_path__ + "static/media/check.ea453444.png";